import LegacyModalAdapter from './LegacyModalAdapter';

const Modal = LegacyModalAdapter;
const SimpleModal = LegacyModalAdapter;
const PlaceholderModal = LegacyModalAdapter;

export { Modal as default, SimpleModal, PlaceholderModal };
